module.exports = __webpack_public_path__ + "static/media/ehealth_cbhr_banner_mobile.3c8f6efe.jpg";